import { Component, inject, INJECTOR, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {AbstractControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {IsValidPipe, MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR, Validators} from '@softline/ui-core';
import * as RegistrationStore from '../../store/registration.store';
import { Store } from '@softline/core';
import { RecaptchaComponent, RecaptchaFormsModule, RecaptchaModule } from "ng-recaptcha-2";
import { passwordValidator } from '../../validation/password.validator';
import { passwordConfirmValidator } from '../../validation/password-confirm.validator';
import { SOFTLINE_FEATURE_REGISTRATION } from '../../registration.shared';


import { InputComponent } from '@softline/ui-core';
import { PasswordInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { ValidationContainerComponent } from '@softline/ui-core';
import { ValidationMessagePipe } from '@softline/ui-core';
import { handleRequestError } from '@softline/application';
@Component({
    selector: 'lib-registration-form',
    imports: [ReactiveFormsModule, RecaptchaModule, RecaptchaFormsModule,
    InputComponent,
    IsValidPipe,
    PasswordInputComponent,
    TranslatePipe,
    ValidationContainerComponent,
    ValidationMessagePipe],
    templateUrl: './registration-form.component.html',
    styleUrls: ['./registration-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [IsValidPipe]
})
export class RegistrationFormComponent implements OnInit {
  readonly #injector = inject(INJECTOR);

  isSubmitting = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', {validators: [Validators.required(), Validators.email()]}),
    password: new UntypedFormControl('', {validators: [passwordValidator({minLength: 8, strengthLevel: 4})]}),
    passwordConfirm: new UntypedFormControl('', {validators: [Validators.required(), passwordConfirmValidator()]}),
    firstName: new UntypedFormControl('', {validators: [Validators.required()]}),
    lastName: new UntypedFormControl('', {validators: [Validators.required()]}),
    company: new UntypedFormControl('', {validators: [Validators.required()]}),
    captcha: new UntypedFormControl('',  {validators: [Validators.required()]}) });

  constructor(private store: Store, private isValidPipe: IsValidPipe) { }

  @ViewChild(RecaptchaComponent) recaptcha?: RecaptchaComponent;

  ngOnInit(): void {}

  async submit(form: AbstractControl): Promise<void> {
    this.isSubmitting = true;
    const isValid = this.isValidPipe.transform(form);
    const value = form.value;

    if (!isValid) {
      return;
    }

    try {
      const user = { ...value, passwordConfirm: undefined };
      const result = await this.store.dispatch(SOFTLINE_FEATURE_REGISTRATION, RegistrationStore.actions.register, { user });

      if (!result) {
        this.recaptcha?.reset();
        await this.showErrorMessage();

      } else {
        const message = {
          title: '#PORTAL_REGISTRATION.CONFIRM.MESSAGES.SUCCESS.TITLE',
          message: '#PORTAL_REGISTRATION.CONFIRM.MESSAGES.SUCCESS.MESSAGE'
        };
        this.form.reset();
        await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.success, message);
      }

      this.isSubmitting = false;
    } catch (e) {
      this.recaptcha?.reset();
      handleRequestError(e, this.#injector, {show: true});
      this.isSubmitting = false;
    } finally {
      this.isSubmitting = false;
    }
  }

  private async showErrorMessage(): Promise<void > {
    const message = '';
    await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, message);
  }
}
